import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.a<{
  position: 'left' | 'right';
}>`
  display: flex;
  min-height: ${rem(36)};
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall)} 0`};
  flex-flow: ${({ position }) => (position === 'left' ? 'row' : 'row-reverse')};
  align-items: center;
  align-content: center;
  justify-content: ${({ position }) => (position === 'left' ? 'flex-start' : 'flex-end')};
  gap: ${rem(10)};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;

export const StyledTitle = styled.div`
  display: flex;
  span {
    line-height: ${rem(18)};
  }
`;

export const StyledIcon = styled.div`
  display: flex;
`;

export const StyledExtraWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
